import "./App.sass";
import "./index.sass";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { UserRoutes } from "./route/user-app-router";
import { AdminRoutes } from "./route/admin-app-router";
import { StudentRoutes } from "./route/student-app-router";
import { NeetRoutes } from "./route/neet-j2e-router";
import SingletonProvider from "./provider/singleton";
import { useSingleton } from "./hooks/use-singleton";
import { Login } from "./components/login";
import { BaseContainer } from "./components/base-container";
import { BaseContainer as AspirantBaseContainer } from "./role-based-code/base-container";
import { BaseContainer as TnpscBaseContainer } from "./tnpsc-component/base-container";
import { BaseContainer as NeetJ2EBaseContainer } from "./neet-j2e/base-container";
import { BaseContainer as BankingBaseContainer } from "./banking/base-container";
import { AdminBaseContainer } from "./components/admin-base-container";
import { TeacherBaseContainer } from "./teacher/base-container";
import { TeacherRoutes } from "./route/teacher-router";
import { CommunicativeRoutes } from "./route/communicative-router";
import NotifyProvider from "./provider/notify";
import { TnpscRoutes } from "./route/tnpsc-route";
import { BankingRoutes } from "./route/banking-routes";
import {
  ROUTE_ACCOUNT_CREATE,
  ROUTE_CHECK_MAIL,
  ROUTE_INFO_SUCCESS,
  ROUTE_NEW_LOGIN,
  ROUTE_PERSONAL_JOURNEY,
  ROUTE_SIGN_UP,
  ROUTE_SUCCESS_PAGE,
} from "./route";
import { SignUp } from "./components/sign-up";
import { Success } from "./components/success";
import AccountCreate from "./components/account-create";
import { PersonalJourney } from "./components/personal-journey";
import { SubscriptionLimitModal } from "./common-components/subscription-limit-modal";
import { NewLogin } from "./components/new-login";
import { CheckMail } from "./components/check-email";
import { InfoSuccess } from "./components/info-success";

function AppContent() {
  const { role, board, examType } = useSingleton();
  return (
    <BrowserRouter>
      <SubscriptionLimitModal />
      <Routes>
        {/* Public */}
        {/* <Route path="/" element={<Login />} /> */}
        <Route path={"/"} element={<NewLogin />} />
        <Route path={ROUTE_SIGN_UP} element={<SignUp />} />
        <Route path={ROUTE_CHECK_MAIL} element={<CheckMail />} />
        <Route path={ROUTE_INFO_SUCCESS} element={<InfoSuccess />} />
        <Route path={ROUTE_ACCOUNT_CREATE} element={<AccountCreate />} />
        <Route path={ROUTE_PERSONAL_JOURNEY} element={<PersonalJourney />} />
        <Route path={ROUTE_SUCCESS_PAGE} element={<Success />} />

        {/* Student */}
        {role === "student" && (
          <Route
            path="/*"
            element={
              <BaseContainer>
                <UserRoutes />
                <CommunicativeRoutes />
              </BaseContainer>
            }
          />
        )}

        {role === "guest" &&
          (examType?.startsWith("CBSE") ||
            examType?.startsWith("TN_STATE_BOARD")) && (
            <Route
              path="/*"
              element={
                <BaseContainer>
                  <UserRoutes />
                </BaseContainer>
              }
            />
          )}

        {/* {role === "aspirant" && (board === "TNPSC" || board === "UPSC") && (
          <Route
            path="/*"
            element={
              <AspirantBaseContainer>
                <StudentRoutes />
              </AspirantBaseContainer>
            }
          />
        )} */}

        {role === "aspirant" && examType?.startsWith("UPSC") && (
          <Route
            path="/*"
            element={
              <AspirantBaseContainer>
                <StudentRoutes />
                <CommunicativeRoutes />
              </AspirantBaseContainer>
            }
          />
        )}

        {role === "guest" && examType?.startsWith("UPSC") && (
          <Route
            path="/*"
            element={
              <AspirantBaseContainer>
                <StudentRoutes />
              </AspirantBaseContainer>
            }
          />
        )}

        {role === "aspirant" && examType?.startsWith("TNPSC") && (
          <Route
            path="/*"
            element={
              <TnpscBaseContainer>
                <TnpscRoutes />
                <CommunicativeRoutes />
              </TnpscBaseContainer>
            }
          />
        )}
        {role === "aspirant" && board === "Banking" && (
          <Route
            path="/*"
            element={
              <BankingBaseContainer>
                <BankingRoutes />
                <CommunicativeRoutes />
              </BankingBaseContainer>
            }
          />
        )}

        {role === "guest" && examType?.startsWith("TNPSC") && (
          <Route
            path="/*"
            element={
              <TnpscBaseContainer>
                <TnpscRoutes />
              </TnpscBaseContainer>
            }
          />
        )}

        {role === "aspirant" && (board === "NEET" || board === "JEE") && (
          <Route
            path="/*"
            element={
              <NeetJ2EBaseContainer>
                <NeetRoutes />
                <CommunicativeRoutes />
              </NeetJ2EBaseContainer>
            }
          />
        )}

        {role === "guest" &&
          (examType?.startsWith("NEET") || examType?.startsWith("JEE")) && (
            <Route
              path="/*"
              element={
                <NeetJ2EBaseContainer>
                  <NeetRoutes />
                </NeetJ2EBaseContainer>
              }
            />
          )}

        {/* Admin */}
        {role === "admin" && (
          <Route
            path="/*"
            element={
              <AdminBaseContainer>
                <AdminRoutes />
              </AdminBaseContainer>
            }
          />
        )}

        {/* Teacher */}
        {role === "teacher" && (
          <Route
            path="/*"
            element={
              <TeacherBaseContainer>
                <TeacherRoutes />
              </TeacherBaseContainer>
            }
          />
        )}

        {role === "ce_user" &&
          examType?.startsWith("Communicative English") && (
            <Route path="/*" element={<CommunicativeRoutes />} />
          )}

        {/* {role === "guest" && (
          <Route path="/*" element={<CommunicativeRoutes />} />
        )} */}

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

function App() {
  return (
    <SingletonProvider>
      <NotifyProvider>
        <AppContent />
      </NotifyProvider>
    </SingletonProvider>
  );
}

export default App;
